import React from "react";
import "./communityNotificationItem.scss";

const TYPE_CONFIG = {
    like: { icon: "♥", label: "좋아요" },
    comment: { icon: "💬", label: "댓글" },
    follow: { icon: "👤", label: "팔로우" },
    mention: { icon: "@", label: "멘션" },
    repost: { icon: "🔄", label: "리포스트" },
    quote: { icon: "💬", label: "인용" },
};

const normalizeType = (type) => {
    if (type?.startsWith("like")) return "like";
    if (type === "comment_on_post" || type === "comment_reply") return "comment";
    if (type?.startsWith("mention")) return "mention";
    return type;
};

const getMessageByType = (type, actorNickname, targetType) => {
    const actor = actorNickname || "알 수 없음";
    const normalizedType = normalizeType(type);

    // 카테고리(좋아요/댓글/멘션 등)는 normalizedType으로 분기하고,
    // 각 case 내부의 세부 문구(게시글 vs 댓글 등)는 원본 type/targetType으로 구분한다.
    switch (normalizedType) {
        case "like":
            return `${actor}님이 회원님의 ${type === "like_comment" || targetType === "comment" ? "댓글" : "게시글"}을 좋아합니다`;
        case "comment":
            return type === "comment_reply" || targetType === "comment"
                ? `${actor}님이 회원님의 댓글에 답글을 남겼습니다`
                : `${actor}님이 회원님의 게시글에 댓글을 남겼습니다`;
        case "follow":
            return `${actor}님이 회원님을 팔로우합니다`;
        case "mention":
            return type === "mention_in_comment" || targetType === "comment"
                ? `${actor}님이 댓글에서 회원님을 언급했습니다`
                : `${actor}님이 게시글에서 회원님을 언급했습니다`;
        case "repost":
            return `${actor}님이 회원님의 게시글을 리포스트했습니다`;
        case "quote":
            return `${actor}님이 회원님의 게시글을 인용했습니다`;
        default:
            return `${actor}님의 알림`;
    }
};

const formatTime = (timestamp) => {
    if (!timestamp) return "";
    const date = new Date(timestamp);
    if (isNaN(date.getTime())) return "";
    const now = new Date();
    const diffInMinutes = Math.floor((now - date) / (1000 * 60));
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInHours / 24);

    if (diffInMinutes < 1) return "방금 전";
    if (diffInMinutes < 60) return `${diffInMinutes}분 전`;
    if (diffInHours < 24) return `${diffInHours}시간 전`;
    if (diffInDays < 7) return `${diffInDays}일 전`;

    return date.toLocaleDateString("ko-KR", {
        month: "long",
        day: "numeric",
    });
};

const CommunityNotificationItem = ({ notification, onClick }) => {
    const { type, target_type, content, is_read, created_at, actor } = notification;
    const actorNickname = actor?.nickname || notification.actor_nickname || null;
    const actorProfileImage = actor?.profile_image || notification.actor_profile_image || null;
    const config = TYPE_CONFIG[normalizeType(type)] || { icon: "🔔", label: "알림" };
    const message = notification.message || getMessageByType(type, actorNickname, target_type);

    return (
        <div
            className={`community-noti-item ${is_read ? "read" : "unread"}`}
            onClick={() => onClick?.(notification)}
        >
            {!is_read && <span className="unread-indicator"></span>}

            <div className="community-noti-avatar">
                {actorProfileImage ? (
                    <img src={actorProfileImage} alt="" className="avatar-img" />
                ) : (
                    <div className="avatar-placeholder">{(actorNickname || "?").charAt(0)}</div>
                )}
                <span className="type-badge">{config.icon}</span>
            </div>

            <div className="community-noti-content">
                <div className="community-noti-header">
                    <p className="community-noti-message">{message}</p>
                    <span className="community-noti-time">{formatTime(created_at)}</span>
                </div>
                {content && (
                    <p className="community-noti-preview">{content}</p>
                )}
            </div>
        </div>
    );
};

export default CommunityNotificationItem;
